import { render, staticRenderFns } from "./StudentFilter.vue?vue&type=template&id=4c528637&scoped=true&"
import script from "./StudentFilter.vue?vue&type=script&lang=js&"
export * from "./StudentFilter.vue?vue&type=script&lang=js&"
import style0 from "./StudentFilter.vue?vue&type=style&index=0&id=4c528637&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c528637",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCheckbox,VCol,VForm,VRow,VSelect})
